import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_AdvancedPreferences } from "../shared/data.service";
import { SendMailRequest } from "../shared/SendMailRequest";

@Component({
	selector: "app-prefs-email-test",
	templateUrl: "./prefs-email-test.component.html",
	styleUrls: ["./prefs-email-test.component.css"],
})
export class PrefsEmailTestComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private advancedPreferencesService: DataService_AdvancedPreferences
	) {}

	ngOnInit(): void {}

	/////////////////////////////////////
	// Data
	/////////////////////////////////////
	Recipients: any = "";
	Message: any = "";
	UsingHTML: any = false;
	Subject: any = "Message from CAASS System";
	FromEmail: any = "no-reply@access411.com";

	processing: any = false;
	errorMessage: any = "";

	/////////////////////////////////////

	/////////////////////////////////////
	// Load Data
	/////////////////////////////////////

	/////////////////////////////////////

	/////////////////////////////////////
	// Buttons
	/////////////////////////////////////
	onSendEmail() {
		this.errorMessage = "";

		//Error handling
		if (this.Recipients == "") {
			this.errorMessage = "Enter an email to send the message to";
			return;
		}

		if (this.Message == "") {
			this.errorMessage = "Enter a message";
			return;
		}

		if (this.FromEmail == "") {
			this.errorMessage = "Enter an address that the message is from";
			return;
		}

		this.processing = true;

		//Create Request
		let parms: SendMailRequest = {
			EmailAddressList: this.Recipients,
			Message: this.Message,
			IsHTML: this.UsingHTML,
			Subject: this.Subject,
			FromEmail: this.FromEmail,
			Attachments: "",
		};

		//Call SP
		var result = this.advancedPreferencesService.SendMail(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email was sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send Email",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onSendNotification() {
		this.errorMessage = "";

		//Error handling
		if (this.Recipients == "") {
			this.errorMessage = "Enter an email to send the message to";
			return;
		}

		if (this.Message == "") {
			this.errorMessage = "Enter a message";
			return;
		}

		if (this.FromEmail == "") {
			this.errorMessage = "Enter an address that the message is from";
			return;
		}

		this.processing = true;

		//Create Request
		let parms: SendMailRequest = {
			EmailAddressList: this.Recipients,
			Message: this.Message,
			IsHTML: this.UsingHTML == true,
			Subject: this.Subject,
			FromEmail: this.FromEmail,
			Attachments: "",
		};

		//Call SP
		var result = this.advancedPreferencesService.SendNotification(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Notification was sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send Notification",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////

	/////////////////////////////////////
	// Events
	/////////////////////////////////////

	/////////////////////////////////////
}
